export const SET_CURRENT_ACTION_ID = 'MAGICLINK/SET_CURRENT_ACTION_ID';
export const SET_LINK_ID = 'MAGICLINK/SET_LINK_ID';
export const STORE_LINK_DETAILS = 'MAGICLINK/STORE_LINK_DETAILS';
export const STORE_ACCESS_DETAILS = 'MAGICLINK/STORE_ACCESS_DETAILS';
export const CLEAR_ACCESS_DETAILS = 'MAGICLINK/CLEAR_ACCESS_DETAILS';
export const STORE_OKYC_META_DATA = 'MAGICLINK/STORE_OKYC_META_DATA';
export const STORE_FINANCE_REPORT_META_DATA =
  'MAGICLINK/STORE_FINANCE_REPORT_META_DATA';
